import Vue from 'vue';
import {LOCALIZED_ERROR_MESSAGES} from '../constants';

export class ErrorHandler {
  handle(error) {
    if (error.isAxiosError) {
      Vue.notify({
        group: 'app',
        title: 'HTTP',
        type: 'error',
        text: LOCALIZED_ERROR_MESSAGES[error.code]
      });
      throw error;
    }

    const response = error.response.data;
    response.error.message = LOCALIZED_ERROR_MESSAGES[response.error.code];
    throw response.error;
  }
}